"use strict";
/* eslint-disable max-lines */
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataUploadConfig = exports.defaultCustomerDataUploadConfig = exports.defaultImportOpportunityConfig = exports.defaultRolesDataUploadConfig = exports.defaultTeamsDataUploadConfig = exports.defaultUsersDataUploadConfig = exports.defaultPriceBookUploadConfig = exports.defaultPriceBookEntriesUploadConfig = exports.defaultLotCatalogConfig = exports.defaultProductCatalogDataConfig = void 0;
exports.defaultProductCatalogDataConfig = [
    {
        key: 'name',
        readableName: 'MAT DESCRIPTION',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            error: 'Product Name cannot be empty',
            prompt: 'Product Name cannot be empty',
        },
    },
    {
        key: 'description',
        readableName: 'MAT DESCRIPTION',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            error: 'Description cannot be empty',
            prompt: 'Description cannot be empty',
        },
    },
    {
        key: 'productCode',
        readableName: 'MAT NUMBER',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            error: 'Product code cannot be empty',
            prompt: 'Product code cannot be empty',
        },
    },
    {
        key: 'catalogCode',
        readableName: 'MAT NUMBER',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            error: 'Catalog code cannot be empty',
            prompt: 'Catalog code cannot be empty',
        },
    },
    {
        key: 'parentProductCode',
        readableName: 'Parent product code',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
    {
        key: 'piecesPerBox',
        readableName: 'AUM',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
    {
        key: 'materialNumber',
        readableName: 'Material number',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            error: 'Material number cannot be empty',
            prompt: 'Material number cannot be empty',
        },
    },
    {
        key: 'listedInCountries',
        readableName: 'Listed in countries (pipe separated)',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            error: 'Listed in countries cannot be empty',
            prompt: 'Listed in countries cannot be empty',
        },
    },
];
exports.defaultLotCatalogConfig = [
    {
        key: 'lotTitle',
        readableName: 'Lot title',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'lotActiveIngredientOrigEn',
        readableName: 'Lot keywords',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'lotDescription',
        readableName: 'Lot description',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'lotQuantity',
        readableName: 'Lot volume or quantity',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'lotForm',
        readableName: 'Product form',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'lotCpvCode',
        readableName: 'CPV code',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'lotStrength',
        readableName: 'Product strength',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'lotStrengthUnit',
        readableName: 'Strength unit',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
];
exports.defaultPriceBookEntriesUploadConfig = [
    {
        key: 'productCode',
        readableName: 'Product code',
        validations: {
            type: 'textLength',
            formulae: [0],
            operator: 'greaterThan',
            allowBlank: false,
            showErrorMessage: true,
        },
    },
    {
        key: 'listPrice',
        readableName: 'List price',
        validations: {
            type: 'textLength',
            formulae: [0],
            operator: 'greaterThan',
            allowBlank: false,
            showErrorMessage: true,
        },
    },
    {
        key: 'name',
        readableName: 'Entry name',
        validations: {
            type: 'textLength',
            formulae: [0],
            operator: 'greaterThanOrEqual',
            allowBlank: true,
            showErrorMessage: true,
        },
    },
];
// Catalog code, country and currency are required while column mapping
exports.defaultPriceBookUploadConfig = [
    {
        key: 'catalogCode',
        readableName: 'Catalog code',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'country',
        readableName: 'Country',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'currency',
        readableName: 'Currency',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'customerCode',
        readableName: 'Customer code',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'customerName',
        readableName: 'Customer name',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'priceGroup',
        readableName: 'Price group',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'customerPrice',
        readableName: 'Customer price',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'listPrice',
        readableName: 'List price',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'discountsPercentage',
        readableName: 'Discounts percentage',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'rebatesPercentage',
        readableName: 'Rebates percentage',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
];
exports.defaultUsersDataUploadConfig = [
    {
        key: 'firstName',
        readableName: 'First name',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'lastName',
        readableName: 'Last name',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'email',
        readableName: 'Email address',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'jobTitle',
        readableName: 'Job title',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'reportsTo',
        readableName: 'Reports to',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'roles',
        readableName: 'Roles',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
];
exports.defaultTeamsDataUploadConfig = [
    {
        key: 'name',
        readableName: 'Name',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'description',
        readableName: 'Description',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'status',
        readableName: 'Status',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
];
exports.defaultRolesDataUploadConfig = [
    {
        key: 'name',
        readableName: 'Role Name',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'description',
        readableName: 'Description',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'permissions',
        readableName: 'Permissions',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
    {
        key: 'status',
        readableName: 'Status',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
        },
    },
];
exports.defaultImportOpportunityConfig = [
    {
        key: 'tenderReference',
        readableName: 'Tender Reference',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            error: 'Tender Reference cannot be empty',
            prompt: 'Tender Reference cannot be empty',
        },
    },
    {
        key: 'country',
        readableName: 'Country',
        validations: {
            type: 'textLength',
            operator: 'equal',
            formulae: [2],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            error: 'Country cannot be empty and must be a two letter ISO code',
            prompt: 'Country cannot be empty and must be a two letter ISO code',
        },
    },
    {
        key: 'tenderUrl',
        readableName: 'Tender URL',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            error: 'Tender URL cannot be empty',
            prompt: 'Tender URL cannot be empty',
        },
    },
    {
        key: 'contractTitle',
        readableName: 'Contract Title',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            error: 'Contract Title cannot be empty',
            prompt: 'Contract Title cannot be empty',
        },
    },
    {
        key: 'contractDurationMonths',
        readableName: 'Contract Duration Months',
        validations: {
            type: 'decimal',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
            showInputMessage: true,
            prompt: 'Should be in number of months',
            error: 'Entered value is not a number. Please check again!',
        },
    },
    {
        key: 'lotNumber',
        readableName: 'Lot Number',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
    {
        key: 'lotTitle',
        readableName: 'Lot Title',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
    {
        key: 'lotQuantity',
        readableName: 'Lot Quantity',
        validations: {
            type: 'decimal',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
            showInputMessage: true,
            prompt: 'Only numbers are allowed',
            error: 'Entered value is not a number. Please check again!',
        },
    },
    {
        key: 'lotValue',
        readableName: 'Lot Value',
        validations: {
            type: 'decimal',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
            showInputMessage: true,
            prompt: 'Only numbers are allowed',
            error: 'Entered value is not a number. Please check again!',
        },
    },
    {
        key: 'contractValue',
        readableName: 'Contract Value',
        validations: {
            type: 'decimal',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
            showInputMessage: true,
            prompt: 'Only numbers are allowed',
            error: 'Entered value is not a number. Please check again!',
        },
    },
    {
        key: 'currency',
        readableName: 'Currency',
        validations: {
            type: 'textLength',
            operator: 'equal',
            formulae: [3],
            allowBlank: true,
            showErrorMessage: true,
            showInputMessage: true,
            prompt: 'Currency must be a three letter ISO code',
            error: 'Currency must be a three letter ISO code',
        },
    },
    {
        key: 'cpvCode',
        readableName: 'CPV Code (comma separated)',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
            showInputMessage: true,
            prompt: 'For multiple values separate each cpv by a comma (,)',
        },
    },
    {
        key: 'nonPriceCriteriaName',
        readableName: 'Non Price Criteria Name (pipe separated)',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
            showInputMessage: true,
            prompt: 'For multiple values separate each criteria name by a pipe (|)',
        },
    },
    {
        key: 'nonPriceCriteriaWeight',
        readableName: 'Non Price Criteria Weight (pipe separated)',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
            showInputMessage: true,
            prompt: 'For multiple values separate each criteria weight by a pipe (|)',
        },
    },
    {
        key: 'priceCriteriaName',
        readableName: 'Price Criteria Name',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
            showInputMessage: true,
            prompt: 'Enter price criteria name',
        },
    },
    {
        key: 'priceCriteriaWeight',
        readableName: 'Price Criteria Weight',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
            showInputMessage: true,
            prompt: 'Enter price criteria weight',
        },
    },
    {
        key: 'startDate',
        readableName: 'Start Date (DD/MM/YYYY)',
        validations: {
            type: 'date',
            formulae: [],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            prompt: 'It should be excel date of format DD/MM/YYYY',
        },
    },
    {
        key: 'dueDate',
        readableName: 'Due Date (DD/MM/YYYY)',
        validations: {
            type: 'date',
            formulae: [],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            prompt: 'It should be excel date of format DD/MM/YYYY',
        },
    },
    {
        key: 'subLotNumber',
        readableName: 'Sub Lot Number',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
    {
        key: 'subLotTitle',
        readableName: 'Sub Lot Title',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
    {
        key: 'subLotQuantity',
        readableName: 'Sub Lot Quantity',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
    {
        key: 'subLotForm',
        readableName: 'Sub Lot Form',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
];
exports.defaultCustomerDataUploadConfig = [
    {
        key: 'customerName',
        readableName: 'Customer name',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            error: 'Customer name cannot be empty',
            prompt: 'Customer name cannot be empty',
        },
    },
    {
        key: 'customerCode',
        readableName: 'Customer code',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            error: 'Customer code cannot be empty',
            prompt: 'Customer code cannot be empty',
        },
    },
    {
        key: 'country',
        readableName: 'Country',
        validations: {
            type: 'textLength',
            operator: 'equal',
            formulae: [2],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            error: 'Country cannot be empty and must be a two letter ISO code',
            prompt: 'Country cannot be empty and must be a two letter ISO code',
        },
    },
    {
        key: 'customerType',
        readableName: 'Customer type',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: false,
            showErrorMessage: true,
            showInputMessage: true,
            error: 'Customer type should be either of PUBLIC_SOLD_TO or PUBLIC_SHIP_TO and cannot be empty',
            prompt: 'Customer type should be either of PUBLIC_SOLD_TO or PUBLIC_SHIP_TO and cannot be empty',
        },
    },
    {
        key: 'addressLine1',
        readableName: 'Address line 1',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
    {
        key: 'addressLine2',
        readableName: 'Address line 2',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
    {
        key: 'city',
        readableName: 'City',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
    {
        key: 'state',
        readableName: 'State',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
    {
        key: 'zipCode',
        readableName: 'ZIP code',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
    {
        key: 'customerTelephone',
        readableName: 'Customer telephone',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
    {
        key: 'customerEmail',
        readableName: 'Customer email',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
    {
        key: 'customerUrl',
        readableName: 'Customer url',
        validations: {
            type: 'textLength',
            formulae: [],
            allowBlank: true,
            showErrorMessage: true,
        },
    },
];
exports.getDataUploadConfig = {
    LOTS: exports.defaultLotCatalogConfig,
    PRODUCT: exports.defaultProductCatalogDataConfig,
    PRICE_BOOK: exports.defaultPriceBookUploadConfig,
    TEAMS: exports.defaultTeamsDataUploadConfig,
    USERS: exports.defaultUsersDataUploadConfig,
    ROLES: exports.defaultRolesDataUploadConfig,
    PRICE_BOOK_ENTRIES: exports.defaultPriceBookEntriesUploadConfig,
    CUSTOMERS: exports.defaultCustomerDataUploadConfig,
};
//# sourceMappingURL=data:application/json;base64,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